import React from 'react'
import SVG from 'react-inlinesvg'
import cx from 'clsx'
// Components
import { CategoryNavItem } from '~2023/components/CategoryList'
import { ArrowDownIcon } from '~2023/components/Icons'
// Styles
import useStyles from './CategoryList.style'
// Utils
import { categories } from '~2023/utils'

import { useSelector } from 'react-redux'

const filterSelector = (state) => state.filter

const CategoryList = () => {
  const classes = useStyles()

  const {
    data: { year: filterYear },
  } = useSelector(filterSelector)

  return (
    <section className={cx(classes.categoryList)}>
      <h3 className={cx(classes.categoryListHeading)}>Filter by Category</h3>
      <ul className={cx(classes.categoryListItems)}>
        {categories &&
          categories.map((category) => {
            return (
              <CategoryNavItem
                id={category.id}
                key={`category--${category.id}`}
                name={category.title}
                path={`/${filterYear}/${category.id}`}
              />
            )
          })}
      </ul>
      <button className={cx(classes.scrollBtn)} type="button">
        <SVG
          src={ArrowDownIcon}
          width={18}
          height={20}
          title="Scroll more"
          description="A down facing arrow"
        />
      </button>
    </section>
  )
}

export default CategoryList
